import { Controller } from "@hotwired/stimulus"

// Live character counter for bounded textareas (PWA-friendly: instant
// feedback, no server round-trip). Shows used/max, turns red near the
// limit, and disables submit when empty or over the limit. The textarea
// also carries maxlength (browser hard stop) and the model validates
// server-side — three layers, same number.
export default class extends Controller {
  static targets = ["input", "counter", "submit"]
  static values = { max: Number }

  connect() {
    this.update()
  }

  update() {
    const len = this.inputTarget.value.length
    const max = this.maxValue
    this.counterTarget.textContent = `${len}/${max}`

    const nearLimit = len >= max * 0.9
    this.counterTarget.classList.toggle("text-red-600", nearLimit)
    this.counterTarget.classList.toggle("font-semibold", nearLimit)

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = len === 0 || len > max
    }
  }
}
